import { isTableSpec, isVegaLiteSpec } from '../../components/pages/AiAnalytics/services/chartTypeUtils';
import {
  ASK_OUTCOMES,
  CHART_FAILED_FALLBACK_MESSAGE,
  CHART_NOT_APPLIED_MESSAGE,
  FAILED_STATUSES,
  FINISHED_STATUSES
} from '../../constants/aiAnalytics';

import { POLL_RUNNING } from './askPolling.service';

export function resolveChartPollResult(result) {
  if (FINISHED_STATUSES.includes(result.status) && result.response?.chart_schema) {
    return ASK_OUTCOMES.FINISHED;
  }
  if (FAILED_STATUSES.includes(result.status)) {
    return ASK_OUTCOMES.FAILED;
  }
  return POLL_RUNNING;
}

export function chartFailureMessage(result) {
  return result.error?.message || CHART_FAILED_FALLBACK_MESSAGE;
}

export function normalizeChartSpec(spec) {
  if (!isTableSpec(spec) && !isVegaLiteSpec(spec)) {
    throw new Error(CHART_NOT_APPLIED_MESSAGE);
  }
  return typeof spec === 'string' ? spec : JSON.stringify(spec);
}
